/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupReleaseResponsePayload } from './LookupReleaseResponsePayload';
import {
    LookupReleaseResponsePayloadFromJSON,
    LookupReleaseResponsePayloadFromJSONTyped,
    LookupReleaseResponsePayloadToJSON,
} from './LookupReleaseResponsePayload';

/**
 * 
 * @export
 * @interface LookupReleaseResponse
 */
export interface LookupReleaseResponse {
    /**
     * True if this release is already linked
     * @type {boolean}
     * @memberof LookupReleaseResponse
     */
    linked: boolean;
    /**
     * 
     * @type {LookupReleaseResponsePayload}
     * @memberof LookupReleaseResponse
     */
    payload: LookupReleaseResponsePayload;
}

/**
 * Check if a given object implements the LookupReleaseResponse interface.
 */
export function instanceOfLookupReleaseResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "linked" in value;
    isInstance = isInstance && "payload" in value;

    return isInstance;
}

export function LookupReleaseResponseFromJSON(json: any): LookupReleaseResponse {
    return LookupReleaseResponseFromJSONTyped(json, false);
}

export function LookupReleaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupReleaseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'linked': json['linked'],
        'payload': LookupReleaseResponsePayloadFromJSON(json['payload']),
    };
}

export function LookupReleaseResponseToJSON(value?: LookupReleaseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'linked': value.linked,
        'payload': LookupReleaseResponsePayloadToJSON(value.payload),
    };
}

